/**
 * =============================================================================
 * IDS CRM Web - Small pieces shared by the bulletin pages
 * =============================================================================
 *
 * The list, the detail page and the publish dialog all show a status badge and
 * fault-code chips; one copy keeps "Waiting for review" and the chip format
 * identical wherever an engineer meets them.
 * =============================================================================
 */

import React from 'react';
import { parseFaultCodes } from '../utils/faultCodes';
import { bulletinStatusLabel, bulletinStatusTone } from '../utils/bulletins';

export function BulletinStatusBadge({ bulletin }) {
  return (
    <span className={`bulletin-status bulletin-status-${bulletinStatusTone(bulletin)}`}>
      {bulletinStatusLabel(bulletin)}
    </span>
  );
}

/**
 * The global .fault-code-chip style from TicketDetail.css, so a code on a
 * bulletin looks exactly like the same code on a work log — that match is
 * how an engineer recognises the fix applies to them.
 */
export function FaultCodeChips({ codes }) {
  const list = parseFaultCodes(codes);
  if (list.length === 0) return null;
  return (
    <span className="fault-code-chips bulletin-codes">
      {list.map(code => (
        <span key={code} className="fault-code-chip">{code}</span>
      ))}
    </span>
  );
}
